import { send } from '../../../../../../../src/network';

export type Params = {
  customer_id: number;
  id: number;
};

export async function deleteApiV2CustomersCustomerIdBundleRatingId(
  params: Params
) {
  return await send<void>({
    path: `/api/v2/customers/${params.customer_id}/bundle_ratings/${params.id}/`,
    method: 'DELETE',
  });
}
